import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import Table from 'components/new_ui/Table';
import { useContext } from 'components/Managers/Coaches/Context';
import { useContext as useUsersContext } from 'components/Users/Context';

import useIot from 'components/Common/Iot/Hooks/useIot';
import { PubSub } from 'aws-amplify';

export default function Index({ coaches, cancelCallback, sentCallback }) {
  const inviteDefaultText = 'Please wait, we will start invite process soon.';
  const { actions } = useContext();
  const [loading, setLoading] = useState(false);
  const [inviteInProgres, setInviteInProgres] = useState(false);
  const [inviteProgressText, setInviteProgressText] = useState(inviteDefaultText);

  useIot();

  const { state: stateUsers } = useUsersContext();

  useEffect(() => {
    if (stateUsers.user) {
      PubSub.subscribe(`user-${stateUsers.user.attributes.token}`).subscribe({
        next: ({ value }) => {
          if (value.type === 'invite_coach_progress') {
            setInviteProgressText(`Sending the invitations: ${value.message}`);
          }
          if (value.type === 'invite_coach_progress_finish') {
            setInviteProgressText(inviteDefaultText);
            setInviteInProgres(false);
            sentCallback();
          }
        },
      });
    }
  }, [stateUsers.user]);

  const columns = [
    {
      name: 'Name',
      selector: (row) => row.attributes.full_name,
      sortable: true,
      searchable: false,
    },
    {
      name: 'Email',
      selector: (row) => row.attributes.email,
      sortable: true,
      searchable: false,
    },
  ];

  const sendInvite = () => {
    setLoading(true);
    setInviteInProgres(true);
    actions.invite(coaches.map((item) => item.attributes.email), () => {
      setLoading(false);
    });
  };

  return (
    <Modal show={coaches.length > 0} size="lg">
      {inviteInProgres && (
        <div className="text-center">
          {inviteProgressText}
        </div>
      )}

      {!inviteInProgres && (
        <>
          <Table
            title="Invite Coaches"
            columns={columns}
            data={coaches}
            selectableRows={false}
          />

          <footer>
            <Button
              variant="outline-primary"
              onClick={() => cancelCallback()}
            >
              Cancel
            </Button>

            <Button
              onClick={sendInvite}
              disabled={loading}
            >
              {loading && <LoadingPlaceholder placement="inline" />}
              {' '}
              Invite
            </Button>
          </footer>
        </>
      )}
    </Modal>
  );
}

Index.propTypes = {
  coaches: PropTypes.arrayOf(PropTypes.object).isRequired,
  cancelCallback: PropTypes.func.isRequired,
  sentCallback: PropTypes.func.isRequired,
};
